// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ssnehmposgsczoadycms.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNzbmVobXBvc2dzY3pvYWR5Y21zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4MTY5NjgsImV4cCI6MjA3NDM5Mjk2OH0.8ZQTD37ttM_yAvRb0cEylu8m47AGGRUuHXdeCu9Vlw4";

console.log('🔌 Supabase Config Check:');
console.log('URL:', SUPABASE_URL);
console.log('Key Length:', SUPABASE_PUBLISHABLE_KEY?.length);
console.log('Using Env Var?', !!import.meta.env.VITE_SUPABASE_URL);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});